import React from 'react';

const Contact = () => {

  return (
    <footer className="footer">
      <div>Copyright © 2023. All rights are reserved</div>
    </footer>
  );
};

export default Contact;